<script setup>
import { IconX } from '@tabler/icons-vue';
import { computed, ref, watch } from 'vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import QuestionBaseQuiz from '@/components/Quiz/QuestionBaseQuiz.vue';
import LatexField from '../LatexField.vue';
import { useComputeEngine } from '../../composables/useComputeEngine';

const props = defineProps({
    question: {
        required: true,
    },
    modelValue: {
        required: true,
    },
});

const emit = defineEmits(['update:modelValue']);

const answer = ref(props.modelValue);
function reset() {
    answer.value = null;
}

const { canonical } = useComputeEngine(answer);

const isEmpty = computed(() => {
    return answer.value === '' || answer.value === null;
});

const stringifiedAnswer = computed(() => {
    if (isEmpty.value) {
        return null;
    } else {
        return JSON.stringify({
            latex: answer.value,
            canonical: canonical.value,
        });
    }
});

watch(
    () => stringifiedAnswer.value,
    (newVal) => {
        emit('update:modelValue', newVal);
    },
    { immediate: true },
);

defineOptions({
    name: 'QuestionMathLatexAnswerQuiz',
});
</script>

<template>
    <QuestionBaseQuiz :question="question">
        <div class="mt-1">
            <FormLabel :value="$t('messages.answer')" :for="`answer_${question.question_id}`" />
            <div>
                <LatexField v-model="answer" class="w-full" />
            </div>

            <div class="mt-1">
                <button @click="reset" :class="{ invisible: isEmpty }" class="text-gray-600" type="button">
                    <IconX class="w-6 h-6 inline-block" />
                    {{ $t('messages.delete_answer') }}
                </button>
            </div>
        </div>
    </QuestionBaseQuiz>
</template>
